// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quickMenuContainer {
  margin: 84px 17px 0px 17px;
  background-color: var(--surface-white);
  width: 100%;
  height: calc(100vh - 100px);
  padding: 12px;
}

.quickMenuHeaderButtons {
  display: flex;
  justify-content: space-between;
}

.quickMenuHeaderButtonsLeft {
  display: flex;
  gap: 8px;
}

.quickMenuCardContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.quickMenuInnerContainer {
  margin-top: 12px;
}

.quickMenuProductList {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  overflow-y: scroll;
  height: calc(100vh - 164px);
  scroll-behavior: smooth;
}

.quickMenuProductContainer {
  height: 100%;
}

.createMenuProductListLoader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.noMoreItemsText {
  width: 100%;
  padding: 20px;
  color: #666;
  display: flex;
  justify-content: center;
  align-items: center;
}

.quickMenuCardWrapper {
  height: 100%;
}

/* ── Filter tabs ── */
.quickMenuFilterTabs {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.quickMenuFilterTab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 50px;
  border: 1px solid var(--surface-g1);
  background: var(--surface-white);
  color: var(--surface-g4);
  font-size: 0.813rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.quickMenuFilterTab:hover {
  border-color: #0860e6;
  color: #0860e6;
}

.quickMenuFilterTabActive {
  background: #0860e6;
  border-color: #0860e6;
  color: #fff;
}

.quickMenuFilterTabActive:hover {
  color: #fff;
}

.quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive) {
  border-color: #f59e0b;
  color: #f59e0b;
}

.quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive):hover {
  background: #fef3c7;
  color: #d97706;
}

.quickMenuFilterTabNoInwardActive {
  background: #f59e0b !important;
  border-color: #f59e0b !important;
}

.quickMenuFilterTabBadge {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50px;
  padding: 1px 6px;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.4;
}

.quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive) .quickMenuFilterTabBadge {
  background: #fef3c7;
  color: #d97706;
}

/* ── No Inward empty state ── */
.noInwardEmptyState {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 8px;
  text-align: center;
}

.noInwardEmptyStateTitle {
  font-size: 1rem;
  font-weight: 700;
  color: var(--surface-g5);
}

.noInwardEmptyStateDesc {
  font-size: 0.875rem;
  color: var(--surface-g3);
  max-width: 320px;
}

/* ── Dark mode ── */
.dark .quickMenuContainer {
  background-color: #1e293b;
  color: #f1f5f9;
}

.dark .noMoreItemsText {
  color: #94a3b8;
}

.dark .quickMenuFilterTab {
  background: #0f172a;
  border-color: #334155;
  color: #94a3b8;
}

.dark .quickMenuFilterTab:hover {
  border-color: #0860e6;
  color: #93c5fd;
}

.dark .quickMenuFilterTabActive {
  background: #0860e6;
  border-color: #0860e6;
  color: #fff;
}

.dark .quickMenuFilterTabActive:hover {
  color: #fff;
}

.dark .quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive) {
  border-color: #f59e0b;
  color: #fbbf24;
}

.dark .quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive):hover {
  background: #292524;
  color: #fbbf24;
}

.dark .quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive) .quickMenuFilterTabBadge {
  background: #292524;
  color: #fbbf24;
}

.dark .noInwardEmptyStateTitle {
  color: #f1f5f9;
}

.dark .noInwardEmptyStateDesc {
  color: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/CreateMenu/index.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,WAAW;EACX,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".quickMenuContainer {\n  margin: 84px 17px 0px 17px;\n  background-color: var(--surface-white);\n  width: 100%;\n  height: calc(100vh - 100px);\n  padding: 12px;\n}\n\n.quickMenuHeaderButtons {\n  display: flex;\n  justify-content: space-between;\n}\n\n.quickMenuHeaderButtonsLeft {\n  display: flex;\n  gap: 8px;\n}\n\n.quickMenuCardContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.quickMenuInnerContainer {\n  margin-top: 12px;\n}\n\n.quickMenuProductList {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  overflow-y: scroll;\n  height: calc(100vh - 164px);\n  scroll-behavior: smooth;\n}\n\n.quickMenuProductContainer {\n  height: 100%;\n}\n\n.createMenuProductListLoader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.noMoreItemsText {\n  width: 100%;\n  padding: 20px;\n  color: #666;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.quickMenuCardWrapper {\n  height: 100%;\n}\n\n/* ── Filter tabs ── */\n.quickMenuFilterTabs {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.quickMenuFilterTab {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 50px;\n  border: 1px solid var(--surface-g1);\n  background: var(--surface-white);\n  color: var(--surface-g4);\n  font-size: 0.813rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.quickMenuFilterTab:hover {\n  border-color: #0860e6;\n  color: #0860e6;\n}\n\n.quickMenuFilterTabActive {\n  background: #0860e6;\n  border-color: #0860e6;\n  color: #fff;\n}\n\n.quickMenuFilterTabActive:hover {\n  color: #fff;\n}\n\n.quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive) {\n  border-color: #f59e0b;\n  color: #f59e0b;\n}\n\n.quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive):hover {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.quickMenuFilterTabNoInwardActive {\n  background: #f59e0b !important;\n  border-color: #f59e0b !important;\n}\n\n.quickMenuFilterTabBadge {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 50px;\n  padding: 1px 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n.quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive) .quickMenuFilterTabBadge {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n/* ── No Inward empty state ── */\n.noInwardEmptyState {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  gap: 8px;\n  text-align: center;\n}\n\n.noInwardEmptyStateTitle {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--surface-g5);\n}\n\n.noInwardEmptyStateDesc {\n  font-size: 0.875rem;\n  color: var(--surface-g3);\n  max-width: 320px;\n}\n\n/* ── Dark mode ── */\n.dark .quickMenuContainer {\n  background-color: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .noMoreItemsText {\n  color: #94a3b8;\n}\n\n.dark .quickMenuFilterTab {\n  background: #0f172a;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .quickMenuFilterTab:hover {\n  border-color: #0860e6;\n  color: #93c5fd;\n}\n\n.dark .quickMenuFilterTabActive {\n  background: #0860e6;\n  border-color: #0860e6;\n  color: #fff;\n}\n\n.dark .quickMenuFilterTabActive:hover {\n  color: #fff;\n}\n\n.dark .quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive) {\n  border-color: #f59e0b;\n  color: #fbbf24;\n}\n\n.dark .quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive):hover {\n  background: #292524;\n  color: #fbbf24;\n}\n\n.dark .quickMenuFilterTabNoInward:not(.quickMenuFilterTabActive) .quickMenuFilterTabBadge {\n  background: #292524;\n  color: #fbbf24;\n}\n\n.dark .noInwardEmptyStateTitle {\n  color: #f1f5f9;\n}\n\n.dark .noInwardEmptyStateDesc {\n  color: #94a3b8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
